import './ClientDetails.scss';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadAppointmentsRequests } from 'actions/appointments';
import ClientDetailsDrawerLoader from 'organisms/Loaders/ClientDetailsDrawerLoader';
import NewAppointmentButton from 'organisms/NewAppointmentButton';
import { openDrawer } from 'store/reducers/ui';
import { isNotEmptyArray } from 'util';

import PetInfo from '../Appointment/PetInfo';
import SummaryInfo from '../Appointment/SummaryInfo';
import PastAppointments from './PastAppointments';
import PetNotes from './PetNotes';
import Vaccinations from './Vaccinations';

export default function ClientDetailsDrawer() {
  const dispatch = useDispatch();
  const { auid, page, query } =
    useSelector((state) => state.ui.drawer.data) || {};
  const [petInformation, setPetInformation] = useState();
  const { petAppointments } = useSelector((state) => state.petInformation);
  const { active, past } = petAppointments;
  const pastAppointments = past;
  const bookedAppointments = active;
  const nextAppointment = isNotEmptyArray(bookedAppointments)
    ? bookedAppointments[0]
    : null;

  useEffect(() => {
    if (auid) {
      dispatch(loadAppointmentsRequests(auid)).then(({ success, data }) => {
        if (success) {
          const { animal, user } = data.data;
          setPetInformation({ animal, user });
        }
      });
    }
  }, [auid]);

  const onEditDetails = () => {
    dispatch(
      openDrawer({
        type: 'edit-details',
        data: {
          animal: petInformation?.animal,
          user: petInformation?.user,
          page,
          query,
        },
      })
    );
  };

  if (!petInformation) return <ClientDetailsDrawerLoader />;

  const { animal, user } = petInformation;
  const newAppointmentData = {
    client: {
      avatarUrls: animal?.avatarUrls,
      breed: animal?.breed,
      name: animal?.name,
      size: animal?.size,
      type: animal?.type,
      uuid: animal?.uuid,
      owner: {
        firstName: user?.firstName,
        lastName: user?.lastName,
        payment: user?.payment,
        phone: user?.phone,
        email: user?.email,
        uuid: user?.uuid,
      },
    },
  };

  return (
    <div className="client-details-drawer flex-column">
      <div className="w-100 flex-column">
        <h2 className="f26 mb-24">Client details</h2>
        <PetInfo animalObj={animal} userObj={user} onEdit={onEditDetails} />
        {nextAppointment && <SummaryInfo appointmentObj={nextAppointment} />}
        <PetNotes auid={animal?.uuid} note={animal?.note} />
        <Vaccinations
          vaccinations={animal?.vaccinations}
          onEdit={onEditDetails}
        />
        <PastAppointments
          pastAppointments={pastAppointments}
          auid={animal?.uuid}
        />
        <div className="flex-row justify-end">
          <NewAppointmentButton data={newAppointmentData} variant="default" />
        </div>
      </div>
    </div>
  );
}
